import React from 'react';
import { useTranslation } from 'react-i18next';
import { KoobBadge } from '@koob/ui';

const STATUS_BADGE = {
  confirmed: { color: 'green', label: 'confirmed' },
  pre_confirmed: { color: 'purple', label: 'pre_confirmed' },
  pending: { color: 'orange', label: 'pending' },
  pending_source: { color: 'orange', label: 'pending' },
  sent: { color: 'blue', label: 'sent' },
  canceled: { color: 'red', label: 'cancelled' },
  refused: { color: 'red', label: 'refused' },
  failed: { color: 'red', label: 'failed' },
  draft: { color: 'amber', label: 'draft' },
  failure: { color: 'red', label: 'failure' },
  replaced: { color: 'purple', label: 'replaced' },
  booked: { color: 'blue', label: 'booked' },
} as const;

export default function BookingStatusBadge({ status }: { status?: string }) {
  const { t } = useTranslation('folders', { keyPrefix: 'bookings' });
  const badge =
    STATUS_BADGE[status as keyof typeof STATUS_BADGE] ??
    ({ color: 'orange', label: 'new' } as const);

  return (
    <div className="flex justify-end">
      <KoobBadge dot color={badge.color}>
        {t(`status.${badge.label}`)}
      </KoobBadge>
    </div>
  );
}
